/**
 * CardContent Component
 * Encapsulated CardContent with consistent styling
 */

import React from 'react';
import { CardContent as MuiCardContent, CardContentProps as MuiCardContentProps } from '@mui/material';

export interface CardContentProps extends MuiCardContentProps {
  noPadding?: boolean; // If true, removes padding (for tables)
}

export const CardContent: React.FC<CardContentProps> = ({ 
  noPadding = false,
  sx,
  children,
  ...props 
}) => {
  const defaultStyles = noPadding
    ? {
        padding: 0,
        '&:last-child': {
          paddingBottom: 0,
        },
      }
    : {};

  return (
    <MuiCardContent
      sx={{
        ...defaultStyles,
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiCardContent>
  );
};

